module.exports = __webpack_public_path__ + "static/media/tenby-five.3264c871.otf";